<template>
    <div style="position: relative;">
        <!------- View ------->
        <b-navbar-nav v-if="profile.mode == 'VIEW'">
            <b-nav-item
                v-if="isCanEdit"
                @click="editWebform()"
                :disabled="!isDetailsLoaded"
            >
                <i class="cus-page-white-edit"></i>Edit Form
            </b-nav-item>

            <b-nav-item-dropdown
                :disabled="!isDetailsLoaded"
                v-if="isCanExport"
            >
                <template slot="button-content">
                    <spinner v-if="isExporting" />
                    <i v-else class="cus-page-attach"></i>
                    Export
                </template>
                <b-dropdown-item
                    v-if="
                        isCanSend &&
                        (!checkExtensionsSMSEnabled ||
                            (checkExtensionsSMSEnabled && !isClientHasMobile))
                    "
                    disabled
                    v-b-tooltip.hover="{
                        placement: 'topleft',
                        title: !checkExtensionsSMSEnabled
                            ? CCLIENT.ALERT_MESSAGE.EXTENSION_SMS_DISABLED
                            : CCLIENT.ALERT_MESSAGE.MOBILE_NOT_EXIST
                    }"
                >
                    <i class="cus-phone disabled-icon"></i>
                    <span class="text-muted">Text (SMS) Form</span>
                </b-dropdown-item>
                <b-dropdown-item
                    v-else-if="
                        isCanSend &&
                        checkExtensionsSMSEnabled &&
                        isClientHasMobile
                    "
                    @click="sendSMS()"
                >
                    <i class="cus-phone"></i>
                    Text (SMS) Form
                </b-dropdown-item>

                <b-dropdown-item
                    v-if="isCanSend && isClientHasEmail"
                    @click="sendEmail()"
                >
                    <i class="cus-email"></i>
                    Email Form
                </b-dropdown-item>
                <b-dropdown-item
                    v-else-if="isCanSend && !isClientHasEmail"
                    disabled
                    v-b-tooltip.hover="{
                        placement: 'left',
                        title: CCLIENT.ALERT_MESSAGE.EMAIL_NOT_EXIST
                    }"
                >
                    <i class="cus-email disabled-icon"></i>
                    <span class="text-muted">Email Form</span>
                </b-dropdown-item>
                <b-dropdown-item v-if="isEnablePrint" @click="printWebform()">
                    <i class="cus-printer"></i>
                    Print Form
                </b-dropdown-item>
            </b-nav-item-dropdown>

            <!-- CHECK IF NOT SENT -->
            <b-nav-item
                v-if="isCanDelete"
                @click="deleteWebform"
                :disabled="!isDetailsLoaded"
            >
                <i class="cus-delete"></i>Delete Form
            </b-nav-item>
        </b-navbar-nav>
        <!------- Edit ------->
        <b-navbar-nav v-if="profile.mode == 'EDIT' && profile.isSaving">
            <b-nav-item>
                Saving...
            </b-nav-item>
        </b-navbar-nav>
        <b-navbar-nav
            v-if="profile.mode == 'EDIT' && profile.isSaving === false"
        >
            <b-nav-item @click="saveEditWebform">
                <i class="cus-disk"></i>Save + Done
            </b-nav-item>
            <b-nav-item @click="cancelEdit">
                <i class="cus-cancel"></i>Cancel
            </b-nav-item>
        </b-navbar-nav>
    </div>
</template>
<script>
import WebformMixin from "@/mixins/webform";
import { isEmpty } from "lodash";
import CCLIENT from "@/constants/clients";

export default {
    mixins: [WebformMixin],
    components: {
        Spinner: () => import("@/components/elements/spinner")
    },
    data() {
        return {
            CCLIENT,
            isExporting: false
        };
    },
    props: {
        profile: {
            type: Object,
            required: true
        }
    },
    computed: {
        webform() {
            return this.$store.state.webform.details;
        },
        webformContent() {
            return this.$store.state.webform.webformContent;
        },
        isDetailsLoaded() {
            return this.webform != null;
        },
        isCanEdit() {
            return this.webform && this.webform.isEnableEdit;
        },
        isCanDelete() {
            return this.webform && this.checkCanDelete(this.webform);
        },
        isCanSend() {
            return this.webform && this.checkCanSend(this.webform);
        },
        isCanExport() {
            return this.webform;
        },
        isClientHasMobile() {
            return (
                this.webform &&
                this.webform.client &&
                this.webform.client.mobile
            );
        },
        isClientHasEmail() {
            return (
                this.webform && this.webform.client && this.webform.client.email
            );
        },
        isEnablePrint() {
            return this.webform && this.checkCanPrint(this.webform);
        }
    },
    watch: {},
    methods: {
        async saveEditWebform() {
            if (this.$store.state.webform.editDetails.isTitleExceed) {
                return null;
            }
            this.$emit("changeIsSaving", true);
            await this.$store
                .dispatch("webform/updateWebform", this)
                .then(response => {
                    if (response) {
                        this.$emit("changeEditMode", false);
                        this._message("Successfully updated");
                    } else {
                        throw "Error";
                    }
                })
                .catch(error => {
                    console.error(error);
                    this._message("Cannot update client form", "danger");
                })
                .finally(() => {
                    this.$emit("changeIsSaving", false);
                });
        },
        sendEmail() {
            if (this.checkCanSendWebform(this.webformContent)) {
                this.$emit("sendEmail", this.webform);
            }
        },
        sendSMS() {
            if (this.checkCanSendWebform(this.webformContent)) {
                this.$emit("sendSMS", this.webform);
            }
        },
        deleteWebform() {
            this.$emit("deleteWebform", this.webform);
        },
        editWebform() {
            this.$store.commit("webform/setEditMode", true);
            this.$emit("changeEditMode", true);
        },
        cancelEdit() {
            this.$store.dispatch("webform/cancelEdit");
            this.$emit("changeEditMode", false);
        },
        async printWebform() {
            if (this.checkCanSendWebform(this.webformContent, "print")) {
                this.isExporting = true;
                await this.printWebformPDF(this.webform);
                this.isExporting = false;
            }
        }
    }
};
</script>
